import styled from 'styled-components'
import arrowImg from '../../assets/arrow.png'
import { useState } from "react";
import { useNavigate } from 'react-router-dom'
import {Cookies} from 'react-cookie';
import moment from "moment";
import PopUp1Mobile from "../../components/PopUp1Mobile";
function Page2Mobile(props) {
  let popup = props.popup
  let goods = props.goods
  const cookies = new Cookies();
  const showTodayFlag = () => {
    if(cookies.get("doNotShowToday")!==null && cookies.get("doNotShowToday") !== undefined){
        if(cookies.get("doNotShowToday") ==  moment().format("YYYYMMDD")){
          return false;
        }else{
          return true;
        }
    }
    return true;
  };

  const [showPopUp, setShowPopUp] = useState(showTodayFlag);
  const doNotShowToday = () => {
    cookies.set("doNotShowToday", moment().format("YYYYMMDD")); 
    setShowPopUp(false);
  };
  const close = () => {
    setShowPopUp(false);
  };

  


  const navigate = useNavigate()

  return (
    <>
    {showPopUp && popup != null ? (
      <PopUp1Mobile doNotShowToday={doNotShowToday} close={close} popup={popup}/>
    ) : null}
    <MainContainer>
      {goods.map((goods) => {
        return (
          <Box
            bgcolor={goods.gsBgColor}
            mainFileDto={goods.gsMainFileDto}
            key={goods.gsSeq}
            onClick={() => {
              navigate(`/goods/${goods.gsSeq}`)
            }}
          >
            <Text1>{goods.gsName}</Text1>
            <Text2>{goods.gsEngName}</Text2>
            <Button>
              <ArrowImg src={arrowImg} />
            </Button>
          </Box>
        )
      })}
    </MainContainer>

    </>
  )
}

export default Page2Mobile
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 66px;
  width: 100vw;
  height: calc(100vh);
  margin-bottom: 60.7px;
`
const Box = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: ${(props) =>
    props.mainFileDto !== null
      ? `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), no-repeat url(${process.env.REACT_APP_BASE_RESOURCES_API}${props.mainFileDto.filePath})`
      : `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), ${props.bgcolor}`};
  background-size: cover;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
const Text1 = styled.p`
  font-size: 13.3px;
  color: #fff;
  font-family: Noto Sans KR;
  font-weight: normal;
`
const Text2 = styled.p`
  font-size: 16.7px;
  color: #fff;
  font-family: GMarketSans;
  font-weight: 500;
  margin-top: 5px;
  letter-spacing: 1px;
`
const Button = styled.div`
  cursor: pointer;
  width: 76.7px;
  height: 23.3px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0.3px solid #fff;
  margin-top: 13px;
`
const ArrowImg = styled.img`
  width: 31px;
  height: 5.7px;
`
